import {
    // NOTE: available in/on the global namespace, not part of this bundle
    activateTooltips,
    updateQueryStringParameter,
} from "../../common";

import {
    EditionsViewer,
} from '../../lib-custom';

import {
    // plugins.reader
    ReaderPanelEnum,
} from "../../plugins";

import { IReaderDefaults, ReaderLayout } from "./readerLayout";
import { SearchModule } from "./searchModule";

function initGoldenReader(
    bookId: string,
    versionId: string,
    bookType: string,
    bookTitle: string,
    pageList: any,
    searchedType: string,
    searchedText?: string,
    initPageId?: string)
{
    // TODO: replace pageId with pageXmlId under the original name
    const pageIdParam = 'pageXmlId';

    function readerPageChangedCallback(pageId: number, pageXmlId: string)
    {
        updateQueryStringParameter(pageIdParam, pageXmlId);
        // TODO: yes, drop once replaced
        updateQueryStringParameter("pageId", pageId);
    }

    var readerPanels = [
        ReaderPanelEnum.TextPanel, ReaderPanelEnum.ImagePanel, ReaderPanelEnum.ContentPanel,
        ReaderPanelEnum.SearchPanel, ReaderPanelEnum.SettingsPanel
    ];

    // XXX: switch to a better, more explicit condition
    //      (bookType?)
    if (searchedType == 'Terms') // 'Fulltext' in editions
        readerPanels.push(ReaderPanelEnum.TermsPanel);

    // TODO: include the author as well and move this deeper
    document.title = `${bookTitle} – Vokabulář webový`;

    const defaults: IReaderDefaults = {
        showPageNames: true,
        showApparatus: true,
        sourceId: 'src',
    };

    var sc = new ServerCommunication();
    var readerPlugin = new ReaderLayout(<any>$("#ReaderHeaderDiv")[0],
        readerPageChangedCallback,
        readerPanels,
        sc,
        defaults
    );
    readerPlugin.makeReader(bookId, versionId, bookType, bookTitle, pageList);

    var searchModule = new SearchModule(<any>$("#SearchDiv")[0], sc, readerPlugin, bookId, versionId, searchedType);
    searchModule.initSearchModule(initPageId, searchedText);

    // NOTE: this should make the state accessible from a developer console
    (window as any).reader = readerPlugin;

    // bibliographyModule should already be available (itjakub.editions.list.*)
    // console.info(readerPlugin, bibliographyModule, bibliographyModule);
    //  XXX: but the BibliographyFactory is usually just now being requested
    // console.info('bibFactory', bibliographyModule.getBibliographyFactory(null));
}

// DONE: import and expose methods to render footnotes and tooltips (for the
//       standalone edition notes page)
function renderEditionNotes(container: HTMLElement)
{
    const viewer = new EditionsViewer();

    viewer.setup({
        root: container,

        // TODO: make this actually configurable
        chars_in_page: 1800,
    });

    viewer.createFootnotesInWholeDocument();
}

export { initGoldenReader, renderEditionNotes };
